import oxfordLogo from "../../media/oxford-logo-long.svg";

const HelpPage = () => {
  const DEV_API_URL = "oxfordstoreacctdev.blob.core.windows.net";
  const PROD_API_URL = "oxfordstoreacctprd.blob.core.windows.net";
  const apiBaseUrl =
    window.location.hostname === "localhost" ? DEV_API_URL : PROD_API_URL;
  return (
    <div className="help-page">
      <img className="oxford-logo-long" src={oxfordLogo} alt="Logo" />
      <div style={{ paddingTop: "20px", fontSize: "xx-large" }}>
        <b>How Can We Help You Today?</b>
      </div>
      <div className="help-card-container">
        <div
          className="help-card"
          onClick={() => {
            window.open(
              `https://${apiBaseUrl}/documents/IAmANewCandidate.pdf`,
              "_blank"
            );
          }}
        >
          <h3>I am a Candidate</h3>
          <i className="bi bi-person-circle"></i>
        </div>

        <div
          className="help-card"
          onClick={() => {
            window.open(
              `https://${apiBaseUrl}/documents/IAmANewClient.pdf`,
              "_blank"
            );
          }}
        >
          <h3>I am a new Client</h3>
          <i className="bi bi-building"></i>
        </div>

        <div
          className="help-card"
          onClick={() => {
            window.open(
              `https://${apiBaseUrl}/documents/IAmAnExistingClient.pdf`,
              "_blank"
            );
          }}
        >
          <h3>I am an existing Client</h3>
          <i className="bi-shield-lock"></i>
        </div>
      </div>
      <div className="questionnaire-header" style={{ paddingTop: "40px" }}>
        If you have additional questions, please call{" "}
        <a href="tel:8008019114" style={{ textDecoration: "none" }}>
          (800) 801-9114
        </a>{" "}
        /{" "}
        <a href="tel:7639710124" style={{ textDecoration: "none" }}>
          (763) 971-0124
        </a>{" "}
        or email{" "}
        <a href="mailto:request@oxforddoc.com">request@oxforddoc.com</a>.
      </div>
    </div>
  );
};

export default HelpPage;
